// extracted by mini-css-extract-plugin
export var fullWidthButton = "_qg-0";